module.exports = __webpack_public_path__ + "static/media/AB_N1_23.2126502d.jpg";